import { render } from "./textMsgAdd.vue?vue&type=template&id=ff1359aa&scoped=true"
import script from "./textMsgAdd.vue?vue&type=script&lang=js"
export * from "./textMsgAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1359aa"]])

export default __exports__